var React = require('react');

function IconSearchInline (props) {
    return React.createElement("path",props);
}

IconSearchInline.defaultProps = {"d":"M17.625,0 C27.3590187,0 35.25,7.89098128 35.25,17.625 C35.25,27.3590187 27.3590187,35.25 17.625,35.25 C7.89098128,35.25 0,27.3590187 0,17.625 C0,7.89098128 7.89098128,0 17.625,0 Z M17.625,5.875 C11.1356542,5.875 5.875,11.1356542 5.875,17.625 C5.875,24.1143458 11.1356542,29.375 17.625,29.375 C24.1143458,29.375 29.375,24.1143458 29.375,17.625 C29.375,11.1356542 24.1143458,5.875 17.625,5.875 Z M27.2978738,27.2978738 C28.3685613,26.2271864 30.0601393,26.1558072 31.2136121,27.0837363 L31.4521262,27.2978738 L45.5521262,41.3978738 C46.6992913,42.5450389 46.6992913,44.4049611 45.5521262,45.5521262 C44.4814387,46.6228136 42.7898607,46.6941928 41.6363879,45.7662637 L41.3978738,45.5521262 L27.2978738,31.4521262 C26.1507087,30.3049611 26.1507087,28.4450389 27.2978738,27.2978738 Z"};

module.exports = IconSearchInline;

IconSearchInline.default = IconSearchInline;
